import * as React from 'react';
import styled from 'react-emotion';

const Container = styled.header`
  font-family: 'Inconsolata', monospace;
  font-size: 16px;
  padding: 3rem;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  color: #626262;
  @media (max-width: 800px) {
    padding: 2em 1em;
  }
`;
const Links = styled.nav`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 500px) {
    flex-grow: 1;
    justify-content: center;
  }
`;

const Logo = styled.div`
  & + ${Links} {
    margin-left: 2rem;
  }
`;
const Link = styled.a`
  font: inherit;
  color: inherit;
  text-decoration: none;
  display: inline-block;
  &:not(:last-child) {
    margin-right: 1em;
    &:after {
      content: '|';
      margin-left: 1em;
    }
  }

  @media (max-width: 800px) {
    &:after {
      content: '';
    }
  }
`;

const Header = ({ logo }: { logo?: React.ReactNode }) => (
  <Container>
    <Links>
      <Link href="mailto:riku@okaycodes.fi">riku@okaycodes.fi</Link>
    </Links>
    {logo && (
      <Logo>
        <Link href="/">{logo}</Link>
      </Logo>
    )}
  </Container>
);

export default Header;
